<template>
  <div class="publicaciones-container" v-frag>
    <CardIeaAppMain colorCard="transparent" title="" class="premium-wrapper">
      <v-col cols="12" class="pa-0">
        
        <!-- Service Inactive Alert -->
        <v-col cols="12" v-if="active == 0" class="px-4">
          <v-alert prominent type="info" class="rounded-xl glass-card">
            El servicio de comunidad se encuentra temporalmente en mantenimiento.
          </v-alert>
        </v-col>

        <div v-else class="content-wrapper">
          <!-- Hero Header -->
          <div class="hero-header glass-panel mb-4 py-3 px-6 mx-2 mx-sm-4 mt-2">
            <div class="d-flex align-center justify-space-between w-100 flex-wrap">
              <div class="d-flex align-center mb-2 mb-md-0">
                <v-btn icon dark color="primary" class="mr-4 glass-btn" @click="$router.go(-1)">
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                <div>
                  <h1 class="text-h5 font-weight-bold primary-text mb-0">Comunidad Académica</h1>
                  <p class="text-caption grey--text text--darken-1 mb-0 d-none d-sm-block">Comparte dudas, experiencias e interactúa con docentes y compañeros</p>
                  <p class="text-caption grey--text text--darken-1 mb-0 d-block d-sm-none">Comunidad y feed académico</p>
                </div>
              </div>

              <!-- Top Quick Filters -->
              <div class="d-flex align-center gap-2">
                <v-btn
                  rounded
                  depressed
                  small
                  :color="getAll == 0 ? 'primary' : 'white'"
                  :class="getAll == 0 ? 'text-white shadow-premium' : 'primary-text border-light'"
                  @click="getAll != 0 ? verAll() : null"
                  class="font-weight-bold text-none px-3"
                >
                  <v-icon left small>mdi-view-dashboard-outline</v-icon>
                  Todo el Campus
                </v-btn>

                <v-btn
                  rounded
                  depressed
                  small
                  :color="getAll == 1 ? 'primary' : 'white'"
                  :class="getAll == 1 ? 'text-white shadow-premium' : 'primary-text border-light'"
                  @click="getAll != 1 ? verAll() : null"
                  class="font-weight-bold text-none px-3"
                >
                  <v-icon left small>mdi-star-outline</v-icon>
                  Mi Feed
                </v-btn>

                <v-btn
                  rounded
                  outlined
                  small
                  color="primary"
                  class="font-weight-bold text-none px-3 glass-btn d-none d-sm-inline-flex"
                  @click="showSearchProfile = true"
                >
                  <v-icon left small>mdi-account-search-outline</v-icon>
                  Buscar
                </v-btn>
              </div>
            </div>
          </div>

          <!-- Main Layout Grid -->
          <div class="px-2 px-sm-4">
            <v-row class="publicaciones-content-row mx-auto" style="max-width: 1300px;">
              
              <!-- LEFT COLUMN: Sticky Mini Profile & Nav -->
              <v-col cols="12" md="4" lg="3">
                <v-card 
                  class="glass-card rounded-xl profile-sticky-card pa-5 text-center mb-4 border-light" 
                  elevation="0" 
                  :style="{ position: $vuetify.breakpoint.mdAndUp ? 'sticky' : 'relative', top: '24px' }"
                >
                  <!-- Avatar User -->
                  <div class="avatar-container mb-3 mx-auto position-relative" style="width: 88px; height: 88px;">
                    <v-avatar
                      class="profile-avatar-premium shadow-md"
                      size="88"
                      style="border: 3px solid white; background: linear-gradient(135deg, #095da1, #8fc6dc);"
                    >
                      <v-img :src="user.imagen" v-if="user && user.imagen && user.imagen !== 'null'"></v-img>
                      <span class="white--text text-h4 font-weight-bold" v-else-if="user">
                        {{ (user.Nombres || user.nombres || 'U').charAt(0).toUpperCase() }}
                      </span>
                    </v-avatar>
                  </div>
                  
                  <h2 class="text-subtitle-1 font-weight-bold primary-text mb-0" v-if="user">
                    {{ user.Nombres || user.nombres }} {{ user.Apellidos || user.apellidos || '' }}
                  </h2>
                  <v-chip x-small color="primary lighten-5" text-color="primary" class="font-weight-bold mt-1 mb-3">
                    <v-icon left x-small>mdi-school</v-icon>
                    {{ user.tipoUsuario === 'profesor' ? 'Docente' : 'Comunidad IEA' }}
                  </v-chip>

                  <v-divider class="my-3 border-light"></v-divider>

                  <!-- Navigation Global Buttons -->
                  <div class="d-flex flex-column gap-2">
                    <v-btn
                      rounded
                      depressed
                      :color="getAll == 0 ? 'primary' : 'transparent'"
                      :class="getAll == 0 ? 'text-white shadow-premium' : 'primary-text border-light'"
                      @click="getAll != 0 ? verAll() : null"
                      class="font-weight-bold text-none justify-start px-4 w-100"
                    >
                      <v-icon left small>mdi-view-dashboard-outline</v-icon> Todo el Campus
                    </v-btn>

                    <v-btn
                      rounded
                      depressed
                      :color="getAll == 1 ? 'primary' : 'transparent'"
                      :class="getAll == 1 ? 'text-white shadow-premium' : 'primary-text border-light'"
                      @click="getAll != 1 ? verAll() : null"
                      class="font-weight-bold text-none justify-start px-4 w-100"
                    >
                      <v-icon left small>mdi-star-outline</v-icon> Mi Feed Personal
                    </v-btn>

                    <v-btn
                      rounded
                      outlined
                      color="primary"
                      @click="$router.push('profile')"
                      class="font-weight-bold text-none justify-start px-4 w-100 glass-btn mt-1"
                    >
                      <v-icon left small>mdi-account-circle-outline</v-icon> Mi Perfil
                    </v-btn>

                    <v-btn
                      rounded
                      outlined
                      color="primary"
                      class="font-weight-bold text-none justify-start px-4 w-100 glass-btn"
                      @click="showSearchProfile = true"
                    >
                      <v-icon left small>mdi-account-search-outline</v-icon> Buscar Personas
                    </v-btn>
                  </div>

                  <!-- Community Tips Card -->
                  <v-card class="rounded-xl pa-3 mt-4 bg-light border-light text-left" elevation="0">
                    <div class="d-flex align-center mb-1">
                      <v-icon x-small color="amber darken-3" class="mr-1">mdi-lightbulb-on-outline</v-icon>
                      <span class="text-caption font-weight-bold primary-text">Espacio Académico</span>
                    </div>
                    <p class="text-caption grey--text text--darken-1 mb-0" style="font-size: 0.75rem !important; line-height: 1.3;">
                      Comparte dudas, experiencias y mantén una comunicación respetuosa con la comunidad.
                    </p>
                  </v-card>
                </v-card>
              </v-col>

              <!-- RIGHT COLUMN: Post Creation & Feed -->
              <v-col cols="12" md="8" lg="9">
                
                <!-- Post Creation Card -->
                <v-card class="glass-card rounded-xl overflow-hidden mb-6 border-light" elevation="0" v-if="usuarioBorrado != 1">
                  <div class="pa-4 pa-sm-5">
                    
                    <div class="d-flex align-center mb-3">
                      <v-avatar size="38" color="primary lighten-4" class="mr-3 border-light">
                        <v-img :src="user.imagen" v-if="user && user.imagen && user.imagen !== 'null'"></v-img>
                        <span v-else class="primary--text font-weight-bold text-subtitle-2">
                          {{ (user.Nombres || user.nombres || 'U').charAt(0).toUpperCase() }}
                        </span>
                      </v-avatar>
                      <div>
                        <div class="text-subtitle-2 font-weight-bold primary-text">
                          {{ action === 'edit' ? 'Editar publicación' : 'Crear una publicación' }}
                        </div>
                        <div class="text-caption grey--text">
                          {{ action === 'edit' ? 'Modifica el contenido de tu publicación' : 'Comparte una consulta o novedad con la comunidad' }}
                        </div>
                      </div>
                    </div>

                    <!-- Emoji Picker Popover -->
                    <div style="position: absolute; right: 20px; z-index: 1000" v-if="showEmojis">
                      <VEmojiPicker
                        class="elevation-6 rounded-xl border-light"
                        @select="selectEmoji"
                        emojiSize="24"
                        emojisByRow="8"
                      />
                    </div>

                    <!-- Textarea with Mentions -->
                    <Mentionable
                      :keys="['@', '#']"
                      :items="followings"
                      offset="6"
                      insert-space
                      @search="searchText = $event"
                      @open="openKey = $event"
                      @close="closeKey = $event"
                      @apply="(item, key) => selectItem(item)"
                    >
                      <v-textarea
                        v-model.trim="content"
                        placeholder="¿Qué quieres compartir hoy? Escribe tus dudas, apuntes o ideas... (Usa @ para mencionar)"
                        no-details
                        auto-grow
                        rows="3"
                        flat
                        solo
                        background-color="#f8fafc"
                        class="rounded-xl border-light post-textarea"
                        @click="showEmojis = false"
                        @focus="showEmojis = false"
                      ></v-textarea>

                      <template #item-@="{ item }">
                        <div class="d-flex align-center pa-1">
                          <v-avatar size="24" color="primary lighten-4" class="mr-2">
                            <v-img :src="item.Avatar" v-if="item.Avatar"></v-img>
                            <v-icon x-small color="primary" v-else>mdi-account</v-icon>
                          </v-avatar>
                          <span class="text-body-2 font-weight-medium">{{ item.value }}</span>
                        </div>
                      </template>
                    </Mentionable>

                    <!-- Hidden Inputs for Files -->
                    <input
                      id="file-upload"
                      type="file"
                      @change="onFileChange"
                      ref="fileInput"
                      style="display: none"
                      multiple
                      accept="image/*"
                    />
                    <input
                      id="file-upload2"
                      type="file"
                      @change="onVideoChange"
                      ref="fileInputVideo"
                      style="display: none"
                      accept="video/*"
                    />

                    <!-- Attachments Preview Area -->
                    <div class="d-flex flex-wrap gap-2 mt-3" v-if="files.length > 0 || video">
                      <div
                        v-for="(file, index) in files"
                        :key="'attach-' + index"
                        class="attachment-box rounded-xl overflow-hidden position-relative border-light"
                      >
                        <img :src="file.id ? file.image : file.url" class="attachment-img" />
                        <v-btn
                          x-small
                          icon
                          dark
                          class="attachment-close-btn"
                          @click="file.id ? deleteFileThumnail(index, file.id) : deleteFileThumnail(index, null)"
                        >
                          <v-icon x-small>mdi-close</v-icon>
                        </v-btn>
                      </div>

                      <div v-if="video" class="attachment-box rounded-xl overflow-hidden position-relative border-light bg-light d-flex flex-column align-center justify-center">
                        <v-icon color="primary" size="32">mdi-video</v-icon>
                        <span class="text-caption grey--text text-truncate px-2" style="max-width: 80px;">Video</span>
                        <v-btn
                          x-small
                          icon
                          dark
                          class="attachment-close-btn"
                          @click="video = null"
                        >
                          <v-icon x-small>mdi-close</v-icon>
                        </v-btn>
                      </div>
                    </div>

                    <!-- Creator Actions Bar -->
                    <div class="d-flex align-center justify-space-between pt-3 mt-3 border-top-light flex-wrap gap-2">
                      <div class="d-flex align-center gap-1">
                        <v-btn
                          rounded
                          text
                          small
                          color="success"
                          @click="uploadFilesEvent()"
                          class="font-weight-bold text-none px-3"
                        >
                          <v-icon left small>mdi-image-outline</v-icon>
                          Imagen
                          <v-chip x-small color="success" text-color="white" class="ml-1 px-1 font-weight-bold" v-if="files.length > 0">
                            {{ files.length }}
                          </v-chip>
                        </v-btn>

                        <v-btn
                          rounded
                          text
                          small
                          color="warning darken-2"
                          @click="uploadVideoEvent()"
                          class="font-weight-bold text-none px-3"
                        >
                          <v-icon left small>mdi-video-outline</v-icon>
                          Video
                          <v-chip x-small color="warning darken-2" text-color="white" class="ml-1 px-1 font-weight-bold" v-if="video">
                            1
                          </v-chip>
                        </v-btn>

                        <v-btn
                          rounded
                          text
                          small
                          color="grey darken-2"
                          @click="showEmojis = !showEmojis"
                          class="font-weight-bold text-none px-3"
                        >
                          <v-icon left small>mdi-emoticon-happy-outline</v-icon>
                          Emoji
                        </v-btn>
                      </div>

                      <div class="d-flex align-center gap-2">
                        <v-btn
                          rounded
                          text
                          color="grey"
                          @click="cancel()"
                          v-if="action == 'edit'"
                          class="font-weight-bold text-none"
                        >
                          Cancelar
                        </v-btn>

                        <v-btn
                          rounded
                          depressed
                          color="primary"
                          class="px-6 font-weight-bold text-none shadow-premium"
                          :disabled="!content && files.length === 0 && !video"
                          @click="action == 'edit' ? editPost() : addPost()"
                        >
                          <v-icon left small>{{ action == 'edit' ? 'mdi-check' : 'mdi-send' }}</v-icon>
                          {{ action == 'edit' ? 'Guardar Cambios' : 'Publicar' }}
                        </v-btn>
                      </div>
                    </div>

                  </div>
                </v-card>

                <!-- Loading Skeletons -->
                <div v-if="loading && publicationsFiltered.length === 0" class="d-flex flex-column gap-4 w-100">
                  <v-card v-for="n in 3" :key="'skel-post-' + n" class="glass-card rounded-xl pa-5 mb-4 border-light" elevation="0">
                    <div class="d-flex align-center mb-3">
                      <div class="skeleton-avatar mr-3"></div>
                      <div class="flex-grow-1">
                        <div class="skeleton-line-title mb-2"></div>
                        <div class="skeleton-line-sub"></div>
                      </div>
                    </div>
                    <div class="skeleton-line-title w-100 mb-2"></div>
                    <div class="skeleton-line-sub w-75 mb-4"></div>
                    <div class="skeleton-media-box rounded-xl"></div>
                  </v-card>
                </div>

                <!-- Empty State -->
                <div v-else-if="!loading && publicationsFiltered.length === 0" class="text-center pa-10 glass-card rounded-xl border-light mb-6">
                  <v-avatar color="primary lighten-5" size="80" class="mb-4">
                    <v-icon size="40" color="primary">mdi-message-text-outline</v-icon>
                  </v-avatar>
                  <h3 class="text-h6 font-weight-bold primary-text">Aún no hay publicaciones</h3>
                  <p class="text-body-2 grey--text text--darken-1 mb-4">
                    {{ getAll == 1 ? 'No tienes publicaciones en tu feed personal. ¡Comienza a seguir a tus compañeros!' : '¡Sé el primero en compartir una novedad con la comunidad académica!' }}
                  </p>
                  <v-btn
                    rounded
                    outlined
                    color="primary"
                    class="font-weight-bold text-none px-6 glass-btn"
                    @click="verAll()"
                    v-if="getAll == 1"
                  >
                    <v-icon left small>mdi-view-dashboard-outline</v-icon>
                    Ver todo el campus
                  </v-btn>
                </div>

                <!-- Feed Stream of Posts -->
                <div v-else class="feed-stream d-flex flex-column gap-4">
                  <v-card
                    v-for="(item, index) in publicationsFiltered"
                    :key="'post-' + item.id"
                    class="glass-card rounded-xl post-card border-light mb-4 overflow-hidden"
                    elevation="0"
                  >
                    <!-- Post Header -->
                    <div class="pa-4 pa-sm-5 pb-2 d-flex align-center justify-space-between">
                      <div class="d-flex align-center cursor-pointer" @click="openProfile(getAuthorId(item), getAuthorRole(item) === 'Docente' ? 'profesor' : 'alumno')">
                        <v-avatar size="44" color="primary lighten-4" class="mr-3 border-light shadow-sm">
                          <v-img :src="getAuthorAvatar(item)" v-if="getAuthorAvatar(item)"></v-img>
                          <span v-else class="primary--text font-weight-bold text-subtitle-1">
                            {{ getAuthorName(item).charAt(0).toUpperCase() }}
                          </span>
                        </v-avatar>
                        <div>
                          <div class="d-flex align-center flex-wrap gap-2">
                            <span class="text-subtitle-2 font-weight-bold primary-text author-name">
                              {{ getAuthorName(item) }}
                            </span>
                            <v-chip x-small :color="getAuthorRole(item) === 'Docente' ? 'warning lighten-5' : 'primary lighten-5'" :text-color="getAuthorRole(item) === 'Docente' ? 'warning darken-3' : 'primary'" class="font-weight-bold">
                              {{ getAuthorRole(item) }}
                            </v-chip>
                          </div>
                          <div class="text-caption grey--text d-flex align-center mt-0">
                            <v-icon x-small color="grey" class="mr-1">mdi-clock-outline</v-icon>
                            Hace {{ gettime(item.updated_at) }}
                          </div>
                        </div>
                      </div>

                      <!-- 3-Dots Author Actions Menu -->
                      <v-menu bottom left offset-y transition="slide-y-transition" v-if="isAuthor(item)">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon small v-bind="attrs" v-on="on" class="opacity-70">
                            <v-icon small>mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>
                        <v-list dense class="rounded-xl pa-1 glass-card" elevation="4">
                          <v-list-item @click="edit(item, index)" class="rounded-lg">
                            <v-list-item-icon class="mr-2">
                              <v-icon small color="primary">mdi-pencil-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title class="text-body-2 font-weight-medium">Editar</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="remove(item.id, index)" class="rounded-lg">
                            <v-list-item-icon class="mr-2">
                              <v-icon small color="error">mdi-trash-can-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title class="text-body-2 font-weight-medium error--text">Eliminar</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>

                    <!-- Post Content Body -->
                    <div class="px-4 px-sm-5 py-2">
                      <div
                        class="post-content-text text-body-1 grey--text text--darken-3"
                        v-html="item.contentHtml"
                      ></div>
                    </div>

                    <!-- Post Media Gallery -->
                    <div class="post-media-area mt-2 mb-2" v-if="activeImages(item).length > 0 || item.video">
                      <!-- Single Image -->
                      <div
                        v-if="activeImages(item).length === 1 && !item.video"
                        class="single-image-wrapper cursor-pointer"
                        @click="openPublication(item)"
                      >
                        <v-img
                          :src="activeImages(item)[0].image"
                          max-height="480"
                          contain
                          class="post-single-image bg-light"
                        ></v-img>
                      </div>

                      <!-- Multiple Images or Video: Carousel -->
                      <v-carousel
                        v-else
                        hide-delimiters
                        :show-arrows="activeImages(item).length > 1 || (activeImages(item).length >= 1 && item.video)"
                        height="360"
                        class="post-carousel bg-light"
                      >
                        <v-carousel-item
                          v-for="(image, j) in activeImages(item)"
                          :key="'car-img-' + j"
                          :src="image.image"
                          contain
                          class="cursor-pointer"
                          @click="openPublication(item)"
                        ></v-carousel-item>

                        <v-carousel-item v-if="item.video">
                          <iframe
                            width="100%"
                            height="100%"
                            :src="item.video"
                            frameborder="0"
                            allow="autoplay; encrypted-media"
                            allowfullscreen
                          ></iframe>
                        </v-carousel-item>
                      </v-carousel>
                    </div>

                    <!-- Post Footer Action Bar -->
                    <div class="px-4 px-sm-5 py-3 border-top-light d-flex align-center justify-space-between flex-wrap gap-2">
                      <div class="d-flex align-center gap-2">
                        <!-- Like Button -->
                        <v-btn
                          rounded
                          text
                          small
                          class="px-3 action-pill-btn"
                          :class="isLiked(item) ? 'liked-btn' : 'neutral-action-btn'"
                          @click="isLiked(item) ? removeLike(item) : addLike(item)"
                        >
                          <v-icon small left :color="isLiked(item) ? 'error' : 'grey darken-1'">
                            {{ isLiked(item) ? 'mdi-heart' : 'mdi-heart-outline' }}
                          </v-icon>
                          <span class="font-weight-bold" :class="isLiked(item) ? 'error--text' : 'grey--text text--darken-2'">
                            {{ totalLikes(item) }}
                          </span>
                        </v-btn>

                        <!-- Comments Button -->
                        <v-btn
                          rounded
                          text
                          small
                          class="px-3 neutral-action-btn action-pill-btn"
                          @click="openPublication(item)"
                        >
                          <v-icon small left color="grey darken-1">mdi-comment-outline</v-icon>
                          <span class="font-weight-bold grey--text text--darken-2">
                            {{ totalComments(item) }}
                          </span>
                        </v-btn>
                      </div>

                      <!-- Liked By Avatars Stack -->
                      <div class="d-flex align-center" v-if="item.likes && item.likes.length > 0">
                        <div class="avatar-stack d-flex align-center">
                          <v-tooltip bottom v-for="(like, i) in item.likes.slice(0, 3)" :key="i">
                            <template v-slot:activator="{ on, attrs }">
                              <v-avatar
                                size="24"
                                v-bind="attrs"
                                v-on="on"
                                class="stack-avatar cursor-pointer elevation-1"
                                @click.stop="openProfile(like.alumno.IDStB, 'alumno')"
                              >
                                <v-img :src="like.alumno.imagen" v-if="like.alumno && like.alumno.imagen"></v-img>
                                <span v-else class="white--text text-caption" style="font-size: 10px !important;">
                                  {{ like.alumno && like.alumno.Nombres ? like.alumno.Nombres.charAt(0) : 'A' }}
                                </span>
                              </v-avatar>
                            </template>
                            <span>{{ like.alumno ? like.alumno.Nombres + ' ' + (like.alumno.Apellidos || '') : '' }}</span>
                          </v-tooltip>
                        </div>
                        <span class="text-caption grey--text ml-2 font-weight-medium" v-if="totalLikes(item) > 3">
                          +{{ totalLikes(item) - 3 }}
                        </span>
                      </div>
                    </div>

                  </v-card>
                </div>

                <!-- Infinite Scroll Loading Indicator -->
                <div v-if="loadingMore" class="text-center py-4">
                  <v-progress-circular indeterminate color="primary" size="32"></v-progress-circular>
                  <div class="text-caption grey--text mt-2">Cargando más publicaciones...</div>
                </div>

                <!-- End of Feed Message -->
                <div v-if="current_page >= last_page && publicationsFiltered.length > 0" class="text-center py-6">
                  <v-avatar color="primary lighten-5" size="44" class="mb-2">
                    <v-icon color="primary" small>mdi-check</v-icon>
                  </v-avatar>
                  <div class="text-caption grey--text font-weight-medium">Has llegado al final de las publicaciones</div>
                </div>

              </v-col>
            </v-row>
          </div>
        </div>

      </v-col>

      <!-- Modals and Dialogs -->
      <ModalCustom
        :show="show"
        @update="onUpdateShow"
        :content="contentAlert"
        :type="typeAlert"
      />
      <Publication
        :showDialog="showPublication"
        @updatepublication="onUpdateShowPublication"
        :publication="publicationSelected"
        :followings="followings"
      />
      <SearchProfile
        :showDialog="showSearchProfile"
        @updatepublication="onUpdateShowSearch"
      />
    </CardIeaAppMain>
  </div>
</template>

<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";
import ModalCustom from "../../components/ModalCustom";
import Publication from "../../components/Publication";
import SearchProfile from "../../components/SearchProfile";
import moment from "moment";
import { VEmojiPicker } from "v-emoji-picker";
import { Mentionable } from "vue-mention";

moment.locale("es");

export default {
  name: "Publicacion",
  components: {
    CardIeaAppMain,
    ModalCustom,
    Publication,
    VEmojiPicker,
    Mentionable,
    SearchProfile
  },

  data: () => ({
    title: "Publicaciones",
    content: "",
    selection: 1,
    show: false,
    contentAlert: "",
    typeAlert: "modal-info",
    showPublication: false,
    publications: [],
    publicationSelected: null,
    loading: false,
    loadingMore: false,
    files: [],
    limit: 10,
    video: null,
    current_page: 0,
    last_page: 1,
    action: "add",
    publication: null,
    current_index: null,
    currentUser: null,
    images_deleted: [],
    active: 1,
    showEmojis: false,
    followers: [],
    followings: [],
    selecteds: [],
    getAll: 0,
    usuarioBorrado: "",
    showSearchProfile: false
  }),

  beforeMount() {
    this.currentUser = this.user.IDStB;
  },

  mounted() {
    if (
      this.$store.getters.user.borrado == 1 ||
      this.$store.getters.user.alumno_mora == true ||
      this.$store.getters.user.excedente
    ) {
      this.$router.push({ name: "Home" });
      return;
    }

    let id = this.$route.params.id;
    this.usuarioBorrado = this.user.borrado;
    this.getUserLogged();
    this.verifierStatus();
    this.getPublications(true);
    window.addEventListener("scroll", this.onScroll);
    if (id) {
      this.getPublication(id);
    }
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },

  computed: {
    user() {
      return this.$store.getters.user;
    },

    publicationsFiltered() {
      const result = [];
      const parseUrl = /(https?:\/\/[^\s<]+)/g;

      for (const p of this.publications) {
        // Las del staff (create_by_client) son avisos a UN alumno (cobranza, notificación
        // masiva): solo las ve el destinatario, como en la vista anterior.
        if (p.create_by_client == true && p.alumno_id != this.user.IDStB) continue;
        const isNotShadowbanned = p.alumno ? p.alumno.shadowban == 0 : true;
        const isOwner = (p.alumno ? p.alumno.IDStB : (p.profesor ? p.profesor.id : null)) == this.user.IDStB;

        if (isNotShadowbanned || isOwner) {
          let text = p.content || "";

          // Process tagged mentions
          if (p.taggeds && p.taggeds.length > 0) {
            p.taggeds.forEach((val) => {
              if (val.shortName) {
                const t = new Date().getTime();
                text = text.split(val.shortName.trim()).join(
                  '<a class="tagged-mention font-weight-bold primary--text text-decoration-none" href="profile/' +
                    val.IDStB +
                    '?t=' +
                    t +
                    '">@' +
                    val.shortName.trim() +
                    '</a>'
                );
              }
            });
          }

          // Process URLs safely
          text = text.replace(parseUrl, (url) => {
            return '<a target="_blank" rel="noopener noreferrer" class="post-url-link font-weight-medium info--text" href="' + url + '">' + url + '</a>';
          });

          p.contentHtml = text;
          result.push(p);
        }
      }
      return result;
    }
  },

  methods: {
    getAuthorName(item) {
      // El API adjunta `cliente` (usuario 92) a TODAS las publicaciones: solo cuenta
      // como autor si la creó el staff (create_by_client), igual que la vista anterior.
      if (item.create_by_client == true && item.cliente && item.cliente.empleado) {
        return (item.cliente.empleado.nombres || '') + ' ' + (item.cliente.empleado.apellidos || '');
      }
      if (item.alumno) {
        return (item.alumno.Nombres || item.alumno.nombres || '') + ' ' + (item.alumno.Apellidos || item.alumno.apellidos || '');
      }
      if (item.profesor && item.profesor.empleado) {
        return (item.profesor.empleado.nombres || '') + ' ' + (item.profesor.empleado.apellidos || '');
      }
      return "Usuario";
    },

    getAuthorAvatar(item) {
      if (item.create_by_client == true && item.cliente && item.cliente.empleado && item.cliente.empleado.imagen) {
        return item.cliente.empleado.imagen;
      }
      if (item.alumno && item.alumno.imagen && item.alumno.imagen !== 'null') {
        return item.alumno.imagen;
      }
      if (item.profesor && item.profesor.empleado && item.profesor.empleado.imagen) {
        return item.profesor.empleado.imagen;
      }
      return null;
    },

    getAuthorRole(item) {
      if (item.profesor) return "Docente";
      if (item.create_by_client == true) return "Staff";
      return "Alumno";
    },

    getAuthorId(item) {
      if (item.alumno) return item.alumno.IDStB;
      if (item.profesor) return item.profesor.IDStB;
      return null;
    },

    isAuthor(item) {
      if (!this.user || !this.user.IDStB) return false;
      if (item.alumno && item.alumno.IDStB == this.user.IDStB && item.type_user == this.user.tipoUsuario) {
        return true;
      }
      if (item.profesor && item.profesor.IDStB == this.user.IDStB && item.type_user == this.user.tipoUsuario) {
        return true;
      }
      return false;
    },

    isLiked(item) {
      if (!this.user || !this.user.IDStB) return false;
      const likedByAlumno = item.likes && item.likes.some(
        d => d.alumno && d.alumno.IDStB == this.user.IDStB && d.type_user == this.user.tipoUsuario
      );
      const likedByProfesor = item.likes_profesor && item.likes_profesor.some(
        d => d.profesor && d.profesor.IDStB == this.user.IDStB && d.type_user == this.user.tipoUsuario
      );
      return !!(likedByAlumno || likedByProfesor);
    },

    totalLikes(item) {
      const l1 = (item.likes && item.likes.length) || 0;
      const l2 = (item.likes_profesor && item.likes_profesor.length) || 0;
      return l1 + l2;
    },

    totalComments(item) {
      const c1 = (item.comments && item.comments.length) || 0;
      const c2 = (item.comments_profesor && item.comments_profesor.length) || 0;
      return c1 + c2;
    },

    activeImages(item) {
      if (!item.images || !Array.isArray(item.images)) return [];
      return item.images.filter(d => d.active == 1);
    },

    selectItem(item) {
      this.selecteds.push(item);
    },

    async getUserLogged() {
      this.$API
        .get(
          {
            url: "alumno/getAlumno",
          },
          false
        )
        .then((res) => {
          if (res && res.followings) {
            res.followings.forEach((val) => {
              if (val.following && val.following.Nombres) {
                let n = val.following.Nombres.trim().replace(" ", ".");
                let i = val.following.imagen
                  ? val.following.imagen
                  : "https://icons.iconarchive.com/icons/papirus-team/papirus-status/256/avatar-default-icon.png";
                this.followings.push({
                  Avatar: i,
                  value: n,
                  id: val.following.IDStB.toString(),
                });
              }
            });
          }
        })
        .catch(err => {
          console.error("Error getUserLogged:", err);
        });
    },

    async verifierStatus() {
      this.$API
        .get(
          {
            url: "publications-service-status",
          },
          false
        )
        .then((res) => {
          this.active = res;
        })
        .catch(() => {});
    },

    onFileChange(e) {
      let all = e.target.files;
      let r = this.files;
      [all].forEach((val) => {
        if (r.length < this.limit) {
          for (const item of val) {
            if (item.type.match("image.*")) {
              item.url = URL.createObjectURL(item);
              r.push(item);
            }
          }
        }
      });
      this.files = Array.from(r);
      if (this.limit == this.files.length) {
        this.contentAlert =
          "El número máximo de imágenes por publicación es " + this.limit;
        this.show = true;
      }
    },

    gettime(date_publish) {
      let current_date = moment();
      let published_date = moment(date_publish);
      return moment.duration(current_date - published_date).humanize();
    },

    onVideoChange(e) {
      let v = e.target.files[0];
      if (v && v.type.match("video.*")) {
        v.uri = URL.createObjectURL(v);
        this.video = v;
      } else {
        this.typeAlert = "info";
        this.contentAlert = "Agrega un formato válido de video";
        this.show = true;
      }
    },

    uploadFilesEvent() {
      this.$refs.fileInput.click();
    },

    uploadVideoEvent() {
      this.$refs.fileInputVideo.click();
    },

    async getPublications(reload = false) {
      if (reload) {
        this.current_page = 0;
        this.last_page = 1;
        this.publications = [];
        this.loading = true;
      } else {
        if (this.current_page >= this.last_page || this.loadingMore) return;
        this.loadingMore = true;
      }

      const nextPage = this.current_page + 1;

      this.$API
        .get(
          {
            url: "publications?page=" + nextPage + "&getAll=" + this.getAll,
            headers: {
              userID: this.currentUser,
            },
          },
          false
        )
        .then((res) => {
          if (res && res.data) {
            if (reload) {
              this.publications = res.data;
            } else {
              this.publications.push(...res.data);
            }
            this.current_page = res.current_page;
            this.last_page = res.last_page;
          }
        })
        .catch(err => {
          console.error("Error al cargar publicaciones:", err);
        })
        .finally(() => {
          this.loading = false;
          this.loadingMore = false;
        });
    },

    async getPublication(id) {
      this.$API
        .get(
          {
            url: "publications/" + id,
          },
          false
        )
        .then((res) => {
          this.openPublication(res);
        })
        .catch(err => {
          console.error("Error getPublication:", err);
        });
    },

    verAll() {
      this.getAll = this.getAll == 0 ? 1 : 0;
      this.getPublications(true);
    },

    openPublication(item) {
      this.showPublication = true;
      this.publicationSelected = item;
    },

    onUpdateShow(newData) {
      this.show = newData;
    },

    onUpdateShowPublication(newData) {
      this.showPublication = newData;
    },

    onUpdateShowSearch(newData) {
      this.showSearchProfile = newData;
    },

    async addPost() {
      if (!this.content && this.files.length === 0 && !this.video) {
        this.contentAlert = "Para poder publicar debes ingresar un texto o adjuntar una imagen/video";
        this.show = true;
        return;
      }

      var formData = new FormData();
      formData.append("content", this.content || "");
      if (this.files.length > 0) {
        formData.append("cantidadImagen", this.files.length);
        let i = 0;
        for (let file of this.files) {
          formData.append("imagen_" + i, file, file.name);
          i++;
        }
      }
      if (this.video) {
        formData.append("video", this.video);
      }

      if (this.selecteds.length > 0) {
        let taggeds = [];
        this.selecteds.forEach((val) => {
          if (this.content && this.content.includes(val.value)) {
            taggeds.push(val.id);
          }
        });
        if (taggeds.length > 0) {
          formData.append("tagged", taggeds.join(","));
        }
      }

      await this.$API
        .post({
          url: "publications",
          data: formData,
        })
        .then((res) => {
          if (res && res.model) {
            this.publications.unshift(res.model);
            this.content = "";
            this.files = [];
            this.video = null;
          }
        })
        .catch(err => {
          console.error("Error addPost:", err);
        });
    },

    async editPost() {
      if (!this.content && this.files.length === 0 && !this.video) {
        this.contentAlert = "El texto de la publicación no puede quedar vacío";
        this.show = true;
        return;
      }

      var formData = new FormData();
      formData.append("content", this.content || "");
      if (this.files.length > 0) {
        formData.append("cantidadImagen", this.files.length);
        let i = 0;
        for (let file of this.files) {
          if (!file.id) {
            formData.append("imagen_" + i, file, file.name);
            i++;
          }
        }
      }
      if (this.images_deleted.length > 0) {
        formData.append("images_delete", this.images_deleted.join(","));
      }
      if (this.video) {
        formData.append("video", this.video);
      }

      await this.$API
        .post({
          url: "publications/" + this.publication.id,
          data: formData,
        })
        .then(() => {
          this.clear();
          this.getPublications(true);
        })
        .catch(err => {
          console.error("Error editPost:", err);
        });
    },

    clear() {
      this.publication = null;
      this.content = "";
      this.images_deleted = [];
      this.files = [];
      this.video = null;
      this.action = "add";
    },

    cancel() {
      this.clear();
      this.getPublications(true);
    },

    async remove(id, index) {
      if (confirm("¿Estás seguro de que deseas eliminar esta publicación?")) {
        await this.$API
          .delete({
            url: "publications/" + id,
            data: {},
          })
          .then((res) => {
            if (res) {
              this.publications.splice(index, 1);
            }
          })
          .catch(err => {
            console.error("Error remove:", err);
          });
      }
    },

    edit(item, index) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      this.action = "edit";
      this.content = item.content;
      this.files = Array.isArray(item.images) ? [...item.images] : [];
      this.video = item.video;
      this.publication = item;
      this.current_index = index;
      this.images_deleted = [];
    },

    async addLike(item) {
      await this.$API
        .post(
          {
            url: "publications-like",
            data: {
              publication_id: item.id,
            },
          },
          false
        )
        .then((res) => {
          if (res) {
            if (res.alumno != null) {
              item.likes.push(res);
            } else {
              item.likes_profesor.push(res);
            }
          }
        })
        .catch(err => {
          console.error("Error addLike:", err);
        });
    },

    async removeLike(item) {
      await this.$API
        .delete(
          {
            url: "publications-like-bypost/" + item.id,
          },
          false
        )
        .then((res) => {
          if (res) {
            item.likes = item.likes.filter((d) => {
              return !d.alumno || d.alumno.IDStB != this.user.IDStB;
            });
            item.likes_profesor = item.likes_profesor.filter((d) => {
              return !d.profesor || d.profesor.IDStB != this.user.IDStB;
            });
          }
        })
        .catch(err => {
          console.error("Error removeLike:", err);
        });
    },

    deleteFileThumnail(index, id) {
      this.files.splice(index, 1);
      if (id) {
        this.images_deleted.push(id);
      }
    },

    onScroll() {
      if (
        document.body.scrollHeight - window.innerHeight - window.scrollY <= 600
      ) {
        this.getPublications(false);
      }
    },

    selectEmoji(emoji) {
      this.content += emoji.data;
    },

    openProfile(id, tipo_usuario) {
      if (!id) return;
      this.$router.push({
        name: "Profile",
        params: {
          id: id,
          tipo_usuario: tipo_usuario,
        },
        query: {
          t: new Date().getTime(),
        },
      });
    }
  }
};
</script>

<style scoped>
.publicaciones-container {
  background: transparent !important;
  min-height: calc(100vh - 120px);
}

.glass-panel {
  background: rgba(255, 255, 255, 0.75) !important;
  backdrop-filter: blur(16px) !important;
  -webkit-backdrop-filter: blur(16px) !important;
  border: 1px solid rgba(255, 255, 255, 0.6) !important;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.05) !important;
  border-radius: 20px;
}

.glass-card {
  background: rgba(255, 255, 255, 0.9) !important;
  backdrop-filter: blur(16px) !important;
  -webkit-backdrop-filter: blur(16px) !important;
  border: 1px solid rgba(255, 255, 255, 0.5) !important;
}

.glass-btn {
  background: rgba(25, 118, 210, 0.08) !important;
  backdrop-filter: blur(4px) !important;
  box-shadow: none !important;
  transition: all 0.25s ease;
}
.glass-btn:hover {
  background: rgba(25, 118, 210, 0.16) !important;
  transform: translateY(-1px);
}

.post-card {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.post-card:hover {
  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.08) !important;
}

.author-name {
  color: #0f172a;
  transition: color 0.2s ease;
}
.author-name:hover {
  color: #1976d2;
}

.post-content-text {
  line-height: 1.6;
  word-break: break-word;
}

.post-single-image {
  border-radius: 16px;
  overflow: hidden;
  max-width: 100%;
}

.post-carousel {
  border-radius: 16px;
  overflow: hidden;
}

.attachment-box {
  width: 88px;
  height: 88px;
  position: relative;
}
.attachment-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.attachment-close-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  background: rgba(0, 0, 0, 0.6) !important;
}
.attachment-close-btn:hover {
  background: rgba(220, 38, 38, 0.9) !important;
}

.action-pill-btn {
  transition: all 0.2s ease;
}
.neutral-action-btn:hover {
  background-color: #f1f5f9 !important;
}
.liked-btn {
  background-color: #fee2e2 !important;
}

.avatar-stack {
  display: flex;
  align-items: center;
}
.stack-avatar {
  border: 2px solid white;
  margin-left: -8px;
  transition: transform 0.2s ease;
}
.stack-avatar:first-child {
  margin-left: 0;
}
.stack-avatar:hover {
  transform: translateY(-2px) scale(1.1);
  z-index: 2;
}

/* Skeleton Loaders */
@keyframes skeletonPulse {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.skeleton-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: linear-gradient(90deg, #e2e8f0 25%, #f8fafc 50%, #e2e8f0 75%);
  background-size: 200% 100%;
  animation: skeletonPulse 1.6s infinite ease-in-out;
}

.skeleton-line-title {
  height: 14px;
  width: 40%;
  border-radius: 999px;
  background: linear-gradient(90deg, #e2e8f0 25%, #f8fafc 50%, #e2e8f0 75%);
  background-size: 200% 100%;
  animation: skeletonPulse 1.6s infinite ease-in-out;
}

.skeleton-line-sub {
  height: 10px;
  width: 25%;
  border-radius: 999px;
  background: linear-gradient(90deg, #e2e8f0 25%, #f8fafc 50%, #e2e8f0 75%);
  background-size: 200% 100%;
  animation: skeletonPulse 1.6s infinite ease-in-out;
}

.skeleton-media-box {
  height: 220px;
  width: 100%;
  background: linear-gradient(90deg, #e2e8f0 25%, #f8fafc 50%, #e2e8f0 75%);
  background-size: 200% 100%;
  animation: skeletonPulse 1.6s infinite ease-in-out;
}

.shadow-premium {
  box-shadow: 0 6px 20px -4px rgba(25, 118, 210, 0.45) !important;
}

.border-light { border: 1px solid rgba(0, 0, 0, 0.06) !important; }
.border-top-light { border-top: 1px solid rgba(0, 0, 0, 0.06); }
.bg-light { background-color: #f8fafc !important; }
.primary-text { color: #0f172a; }
.gap-1 { gap: 4px; }
.gap-2 { gap: 8px; }
.gap-3 { gap: 12px; }
.gap-4 { gap: 16px; }
.opacity-70 { opacity: 0.7; }
</style>
